/* Keeps Shopify Inbox behavior intact while applying the approved launcher styling. */
(() => {
  const findActivatorRoot = (node) => {
    if (!node || !node.shadowRoot) return null;
    const root = node.shadowRoot;
    if (root.querySelector('.activator')) return root;
    for (const child of root.querySelectorAll('*')) {
      const found = findActivatorRoot(child);
      if (found) return found;
    }
    return null;
  };
  const applyLauncherStyle = () => {
    const root = findActivatorRoot(document.querySelector('shopify-chat, shopify-agent'));
    if (!root || root.querySelector('[data-sofacover-orange-launcher]')) return false;
    const activator = root.querySelector('.activator');
    const icon = root.querySelector('.activator__icon');
    if (!activator || !icon) return false;
    const style = document.createElement('style');
    style.setAttribute('data-sofacover-orange-launcher', '');
    style.textContent = `
      .activator { --activator-fg:#ffffff !important; --activator-bg:#e8753b !important; width:48px !important; height:48px !important; border-radius:8px !important; box-shadow:0 5px 16px rgba(113,55,28,.22) !important; }
      .activator__icon { width:23px !important; height:23px !important; color:#ffffff !important; display:grid !important; place-items:center !important; }
      .activator__icon > * { display:none !important; }
      .activator__icon::before { content:none !important; display:none !important; }
      .activator__icon::after { content:''; display:block; width:17px; height:13px; border:1.8px solid currentColor; border-radius:4px; box-sizing:border-box; background:linear-gradient(135deg,transparent 45%,currentColor 46%,currentColor 54%,transparent 55%) right bottom/6px 6px no-repeat; }
    `;
    root.append(style);
    return true;
  };
  const timer = window.setInterval(() => { if (applyLauncherStyle()) window.clearInterval(timer); }, 100);
  window.setTimeout(() => window.clearInterval(timer), 15000);
})();
